import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import loadLang from "@/lang/loadLang"; // 多语言
import i18n from './lang'
// import flexible from "amfe-flexible"
import { Icon, Toast, Overlay, Checkbox } from 'vant'
import 'vant/lib/index.css'

Vue.use(Icon)
Vue.use(Toast)
Vue.use(Overlay)
Vue.use(Checkbox)
// Vue.prototype.flexible = flexible

// new Vue({
//   store,
//   router,
//   render: (h) => h(App)
// }).$mount('#app')

loadLang.loadRemoteLangs({}).then(res => {
  console.log('[20230613]', 'app.$mount')
  new Vue({
    store,
    router,
    i18n,
    render: h => h(App),
  }).$mount('#app')
  
});
